<template>
  <d2-container>
    <el-select @keyup.enter.native="getNewsList" v-model="listQuery.type" clearable placeholder="请选择支付状态" size="small"
      style="margin-top:5px;margin-right: 20px;">
      <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <el-button @click="getNewsList" class="filter-item" type="primary" icon="search" size="small"
      style="margin-top:5px;">搜索</el-button>
    <el-table size="small" :key="tableKey" stripe border highlight-current-row style=" margin-top: 20px"
      :data="newsList">
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="模板名称">
        <template slot-scope="scope">
          <span>{{ scope.row.tplName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="跳转链接">
        <template slot-scope="scope">
          <span>{{ scope.row.skipUrl }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="跳转信息">
        <template slot-scope="scope">
          <span>{{ scope.row.skipInfo }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column align="center" label="可用变量">
        <template slot-scope="scope">
          <span>{{ scope.row.varDesc }}</span>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="内容">
        <template slot-scope="scope">
          <span>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="短信内容">
        <template slot-scope="scope">
          <span>{{ scope.row.smsContent }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">开启</span>
          <span v-if="scope.row.status == 0">关闭</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">系统消息</span>
          <span v-if="scope.row.type == 2">订单消息</span>
          <span v-if="scope.row.type == 3">任务消息</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="getEdit(scope.row)"
            v-permission:function="['newsManasger:btn_edit']" style="margin-top:10px">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" style="width:500px"></el-pagination>
    </template>
    <el-dialog title="修改" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接" prop="skipUrl">
          <el-select clearable placeholder="请选择跳转链接" size="small" style="margin-top:5px;margin-right: 20px;"
            @change="selectChanged" v-model="form.skipUrl">
            <el-option v-for="item in typesLits" :key="item.url" :label="item.name" :value="item.url"></el-option>
          </el-select>
          <el-input v-model="form.skipUrl" placeholder="请输入链接"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="form.content" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="短信内容" prop="smsContent">
          <el-input v-model="form.smsContent" placeholder="请输入短信内容"></el-input>
        </el-form-item>
        <el-form-item label="">
          <!-- <div>{{form.varDesc}}</div> -->
          <el-alert title="可用变量" type="success" :closable="false" :description="form.varDesc"></el-alert>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否开启弹窗" prop="isPop">
          <el-radio-group v-model="form.isPop">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getAdopt('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getNewsList, getNewsUpdate, getTypeLits } from '@/api/demo/news/index'
export default {
  name: 'newsManasger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      newsManasger_btn_edit: false,
      tableKey: 0,
      newsList: [],
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        type: null
      },
      total: 0,
      listLoading: true, // 加载圈圈
      form: {
        id: '',
        title: '',
        content: '',
        remark: '',
        status: 0,
        isPop: 0,
        skipUrl: '',
        varDesc: ''
      },
      rules: {},
      typeList: [
        {
          value: 1,
          label: '系统消息'
        },
        {
          value: 2,
          label: '订单消息'
        },
        {
          value: 3,
          label: '任务消息'
        }
      ],
      dialogFormVisible: false,
      typesLits: []
    }
  },
  created () {
    this.getNewsList()
    this.getTypes()
  },
  mounted () { },
  methods: {
    getNewsList () {
      let that = this
      getNewsList(that.listQuery).then(res => {
        that.listLoading = true
        that.newsList = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getNewsList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getNewsList(val)
    },
    // 选择类型时触发
    selectChanged (value) {
      console.log('e', value)
    },
    // 跳转类型
    getTypes () {
      let that = this
      getTypeLits().then(res => {
        that.typesLits = res
        console.log('that.typesLits', that.typesLits)
      })
    },
    // 修改按钮
    getEdit (row) {
      let that = this
      that.form = row
      console.log('row', that.form)
      that.dialogFormVisible = true
    },
    // 取消
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    getAdopt () {
      let that = this
      getNewsUpdate(that.form.id, that.form).then(res => {
        that.$message({
          message: '修改成功',
          type: 'success',
          center: true
        })
        that.getNewsList()
        this.dialogFormVisible = false
      })
    }
  }
}
</script>
<style>
.el-alert .el-alert__description {
  font-size: 14px !important;
}
</style>
